import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopOnDutyLog(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_duty_log">
      <h2 className="pop_tit">당직 일지</h2>
      <div className="content_container scroll">
        <table className="com_board_list">
          <colgroup>
            <col width="16%" />
            <col width="34%" />
            <col width="16%" />
            <col width="34%" />
          </colgroup>
          <tbody>
            <tr>
              <th>유의사항</th>
              <td colSpan={3}>인사총무팀에서 공지입력만 가능</td>
            </tr>
            <tr>
              <td colSpan={2}>2024 년 월 일 ( 요일)</td>
              <th>유의사항</th>
              <td className="td_right">(서명)</td>
            </tr>
            <tr>
              <th>당직구분</th>
              <td colSpan={3}>평일 / 토요일 / 공휴일</td>
            </tr>
            <tr>
              <th>순찰사항</th>
              <td colSpan={3} className="td_padding_no">
                <table className="com_board_list">
                  <colgroup>
                    <col width="150" />
                    <col width="150" />
                    <col width="auto" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="th_center">시간</th>
                      <th colSpan={2} className="th_center">
                        기제사항
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowSpan={5}>시 분</td>
                      <td>5층</td>
                      <td>홍이지, 박이지, 김이지</td>
                    </tr>
                    {[...Array(4)].map((i, idx) => (
                      <tr key={idx}>
                        <td>5층</td>
                        <td>홍이지, 박이지, 김이지</td>
                      </tr>
                    ))}
                    <tr>
                      <td rowSpan={5}>시 분</td>
                      <td>4층</td>
                      <td>홍이지, 박이지, 김이지</td>
                    </tr>
                    {[...Array(4)].map((i, idx) => (
                      <tr key={idx}>
                        <td>4층</td>
                        <td>홍이지, 박이지, 김이지</td>
                      </tr>
                    ))}
                    <tr>
                      <td rowSpan={5}>시 분</td>
                      <td>B1층</td>
                      <td>홍이지, 박이지, 김이지</td>
                    </tr>
                    {[...Array(4)].map((i, idx) => (
                      <tr key={idx}>
                        <td>B1층</td>
                        <td>홍이지, 박이지, 김이지</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th>수신전화 리스트</th>
              <td colSpan={3} className="td_padding_no">
                <table className="com_board_list">
                  <colgroup>
                    <col width="150" />
                    <col width="auto" />
                    <col width="40" />
                    <col width="140" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>수신번호</th>
                      <th>수신내용</th>
                      <th colSpan={2}>처리결과</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th>방문자 리스트</th>
              <td colSpan={3} className="td_padding_no">
                <table className="com_board_list">
                  <colgroup>
                    <col width="150" />
                    <col width="auto" />
                    <col width="40" />
                    <col width="140" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>방문자</th>
                      <th>방문사유</th>
                      <th colSpan={2}>처리결과</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th>층별 점검사항</th>
              <td colSpan={3} className="td_padding_no">
                <table className="com_board_list">
                  <colgroup>
                    <col width="auto" />
                    <col width="105" />
                    <col width="105" />
                    <col width="105" />
                    <col width="105" />
                    <col width="105" />
                    <col width="105" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>B1층</th>
                      <th>1층</th>
                      <th>2층</th>
                      <th>3층</th>
                      <th>4층</th>
                      <th>5층</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th>사무실 조명</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th>화장실 조명</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th>화장실 창문</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th>창문점검상태</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th>에어컨 전원</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <th>보안시스템/정문상태</th>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th>주차장정리상태</th>
              <td colSpan={3}></td>
            </tr>
            <tr>
              <th>대표이사실 점검사항</th>
              <td colSpan={3} className="td_padding_no">
                <table className="com_board_list">
                  <colgroup>
                    <col width="70" />
                    <col width="130" />
                    <col width="70" />
                    <col width="130" />
                    <col width="70" />
                    <col width="130" />
                    <col width="70" />
                    <col width="130" />
                  </colgroup>
                  <tbody>
                    <tr className="first">
                      <th>전등상태</th>
                      <td></td>
                      <th>창문/청소</th>
                      <td></td>
                      <th>
                        공기
                        <br />
                        청정기
                      </th>
                      <td></td>
                      <th>
                        에어컨/
                        <br />
                        온풍기 상태
                      </th>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th>특별체크 리스트</th>
              <td colSpan={3} className="td_padding_no">
                <table className="com_board_list">
                  <colgroup>
                    <col width="270" />
                    <col width="270" />
                    <col width="270" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>1층 뒷문 잠금상태 확인</th>
                      <th>1층 화장실 뒷문 잠금상태 확인</th>
                      <th>1층 뒤편 지하출입문 잠금상태 확인</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <th>특기할 출입자</th>
              <td colSpan={3}></td>
            </tr>
            <tr>
              <th>기타사항</th>
              <td colSpan={3}>기타사항</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopOnDutyLog;
